const services = [
  "Excavation & Site Work",
  "Concrete Construction",
  "Renovations & Major Home Improvements",
  "New Construction",
  "Commercial & Multifamily Construction",
  "Landscape & Property Improvements",
  "Real Estate Development",
];

export default function Footer() {
  return (
    <footer className="relative border-t border-[#D4AF37]/15 bg-[#030303] overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="flex flex-col items-center mb-8">
          <img
            src="/images/logo.png"
            alt="Veritas Development Group monogram"
            className="h-16 w-auto opacity-90"
            data-testid="footer-logo-image"
          />
          <p className="mt-4 font-display text-lg sm:text-xl tracking-[0.22em] text-[#D4AF37] text-center" data-testid="footer-company-name">
            VERITAS DEVELOPMENT GROUP LLC
          </p>
        </div>
        <div className="mt-16 grid sm:grid-cols-3 gap-12">
          <div>
            <p className="text-[10px] tracking-[0.35em] uppercase text-[#D4AF37] mb-5">Contact</p>
            <a href="tel:+18164056181" data-testid="footer-phone-link" className="block font-display text-2xl text-[#F5F5F5] hover:text-[#D4AF37] transition-colors">
              816-405-6181
            </a>
            <a href="mailto:info@veritasdevelopmentgroupllc.com" data-testid="footer-email-link" className="block mt-3 text-sm font-light text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
              info@veritasdevelopmentgroupllc.com
            </a>
            <a href="mailto:funding@veritasdevelopmentgroupllc.com" data-testid="footer-funding-email-link" className="block mt-3 text-sm font-light text-[#A3A3A3] hover:text-[#D4AF37] transition-colors">
              Funding: funding@veritasdevelopmentgroupllc.com
            </a>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.35em] uppercase text-[#D4AF37] mb-5">Services</p>
            <ul className="space-y-2.5" data-testid="footer-services-list">
              {services.map((s) => (
                <li key={s} className="text-sm font-light tracking-wide text-[#A3A3A3]">{s}</li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] tracking-[0.35em] uppercase text-[#D4AF37] mb-5">Location</p>
            <p className="text-sm font-light leading-relaxed tracking-wide text-[#A3A3A3]" data-testid="footer-location">
              210 SW Market St
              <br />
              Lee's Summit, MO 64063, United States
              <br />
              Proudly serving the Lee's Summit area
              <br />
              and surrounding communities.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]" data-testid="footer-copyright">
            © 2026 Veritas Development Group LLC
          </p>
          <p className="font-display italic text-sm text-[#D4AF37]/80" data-testid="footer-tagline">
            Built on Integrity. Driven by Excellence.
          </p>
        </div>
      </div>
    </footer>
  );
}
